import { FirebaseConfig } from '../models/firebase-config.interface';

export class EnvironmentConfig {
  endPoint: string;
  firebase: FirebaseConfig;
  smartlookKey: string;
  appInsights: {
    instrumentationKey: string;
  };
}
